import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { ThemeOptions } from '../../../../../theme-options';
import {ChangePasswordComponent} from './change-password/change-password.component'
import {WebsocketService} from '@app/shared/service/websocket.service';
@Component({
  selector: 'app-user-box',
  templateUrl: './user-box.component.html',
})
export class UserBoxComponent implements OnInit {

  @ViewChild('changePasswordRef') changePasswordRef:ChangePasswordComponent;
 user:any;
  faCalendar = faCalendar;

  toggleDrawer() {
    this.globals.toggleDrawer = !this.globals.toggleDrawer;
  }

  constructor(public globals: ThemeOptions,private router:Router,public toasterService: ToastrService, public WebsocketService: WebsocketService) {
  }

  ngOnInit() {
    
    this.user=JSON.parse(localStorage.getItem('user'))
    const capitalizeFirstLetter = (str) => {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    };
    
    // Example for 'savedesk' conversion to 'Savedesk'
    this.user.userName = capitalizeFirstLetter(this.user?.userName);
    
    console.log("Userrrrr::"+ this.user);
  }

  logout(){
   // console.log("inside logout")
   this.WebsocketService.CloseAllWebsocketClient();
    localStorage.removeItem("bearer");
    localStorage.removeItem("user");
    this.router.navigateByUrl('pages/login');
    this.toasterService.success("you've been logged out successfully", "Success", {
      positionClass: "toast-top-right",
    });
  }

  changePassword(){
    this.changePasswordRef.open();
  }


}
